import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { MemberProfilePage } from '@/features/members/components/member-profile-page';

function UserProfileRoute(): ReactNode {
  const { userId } = Route.useParams();
  return <MemberProfilePage userId={userId} />;
}

export const Route = createFileRoute('/users/$userId')({
  component: UserProfileRoute,
});
